import { LicenseInfo } from "@mui/x-license-pro";

export const licenseKey =
  "7b95ba9f8a0d972793f7e98cb9abd9e4Tz05NDg3MCxFPTE3NTM0NTc2OTcwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=";

export const setupMuiLicense = () => {
  LicenseInfo.setLicenseKey(licenseKey);
};
